import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CourseLevelIcon from '../../common/icons/CourseLevelIcon';
import EuroIcon from '../../common/icons/EuroIcon';

import ParticipateForm from '../../common/forms/ParticipateForm';

import { getCourseColor } from '../../../utils/course-utils';

const getLevelText = level => {
  if (level === 1) {
    return 'beginner';
  }

  if (level === 2) {
    return 'intermediate';
  }

  return 'advanced';
};

const CoursePrice = props => {
  const btnBgClassName = classnames({
    'is-csharp-bg': props.type === 1,
    'is-javascript-bg': props.type === 2,
    'is-typescript-bg': props.type === 3,
    'is-nodejs-bg': props.type === 4,
  });
  return (
    <div className="course-price">
      <div className="tutorium-container">
        <p className="course-program-title">Leave a request to register for this course</p>
        <div className="course-price-content">
          <div className="course-price-block">
            <p className="course-price-block-title">{props.courseName}</p>
            <div className="is-flex align-items-center my-20px">
              <CourseLevelIcon level={props.level} type={props.type} isColorful={true} />
              <span className="course-price-text ml-10px">Level: {getLevelText(props.level)}</span>
            </div>
            <div style={{ display: 'inline-block' }} className="mt-20px">
              <div className="old-price-block">
                <span>{props.oldPrice}</span>
                <EuroIcon color="black" size={14} />
                <div className="old-price-strikethrough" />
              </div>
            </div>
            <div className="is-flex align-items-center">
              <p className={classnames('new-price-block', props.colorClassNames)}>
                {props.price}
                <EuroIcon color={getCourseColor(props.type)} />
              </p>
              <div className="ml-20px">
                <p className="course-price-text">unique webinars</p>
                <p className="course-price-text">individual tasks</p>
              </div>
            </div>
          </div>

          <div className="course-participate-form-block">
            <ParticipateForm
              btnClassName={classnames('submit-button submit-course-button', btnBgClassName)}
              courseId={props.courseId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CoursePrice.propTypes = {
  courseId: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  courseName: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  oldPrice: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  colorClassNames: PropTypes.string.isRequired,
};

export default CoursePrice;
